import { useOddsTrend } from "@/hooks/useOddsTrend";

const OddsBtnContainer = ({ title, value, trend, noHover, isFirst }) => {
  const {
    isUp,
    isDown,
    animating,
    valueColorClass,
    animationClass
  } = useOddsTrend(trend, value);

  const hasValue =
    value !== null &&
    value !== undefined &&
    value !== "" &&
    value !== "-";

  const borderBgClass = isUp
    ? "border-[var(--theme-border)] bg-[var(--theme-accent)]"
    : isDown
      ? "kbv-border-red-light kbv-bg-red-light"
      : "border-[var(--theme-btn-border)] bg-[var(--theme-foreground)]";

  return (
    <div
      className={`relative box-border flex h-[50px] w-[55px] min-w-0 md:h-[60px] md:w-auto md:min-w-[80px] flex-col items-center justify-center overflow-hidden rounded-[10px] border text-center kbv-shadow-subtle ${borderBgClass} ${animationClass} ${isFirst ? "mt-0" : "mt-[4px] md:mt-3"} ${noHover ? "" : "cursor-pointer hover:border-[var(--theme-border)] hover:bg-[var(--theme-accent)]"}`}
    >
      {isUp && animating && (
        <div className="absolute left-[5px] top-[5px] z-10 animate-triangle-flash kbv-triangle-up-anim" />
      )}
      {isDown && animating && (
        <div className="absolute right-[5px] bottom-[5px] z-10 animate-triangle-flash kbv-triangle-down-anim" />
      )}
      {hasValue ? (
        <>
          {title && (
            <div className="mb-1 text-[14px] md:text-sm text-[var(--theme-text)]">{title}</div>
          )}
          <div className={`h-[18px] text-[16px] font-semibold leading-[18px] ${valueColorClass}`}>
            {value}
          </div>
        </>
      ) : (
        <>
          {title && (
            <div className="mb-1 text-[14px] md:text-sm text-[var(--theme-text)]">{title}</div>
          )}
          <div className="h-[18px] text-[16px] font-semibold leading-[18px] text-[var(--theme-text)]">-</div>
        </>
      )}
    </div>
  );
};

export default OddsBtnContainer;
